import React, { Fragment } from 'react'
import { Box, Typography } from '@material-ui/core'
import useStyles from './styles'
import BidButton from './BidButton'
import DonateButtons from './DonateButtons'
import { useSelector } from 'react-redux'
import FixedButton from './FixedButton'
import classnames from 'clsx'
import { useFullScreen } from 'react-browser-hooks'
import { useMemo, useEffect, useState } from 'react'

const EngagementButtons = ({
  children,
  mobile = false,
  hideControls = false
}) => {
  const classes = useStyles()
  const captionShow = useSelector(state => state.stream.captions)
  const orientation = useSelector(state => state.window.orientation)
  const windowFullscreen = useSelector(state => state.window.fullscreen)
  const authenticatedUser = useSelector(
    state => state.authentication.authenticatedUser
  )
  const { fullScreen } = useFullScreen()
  const videoControlled = useSelector(
    state =>
      state.stream.cloudinaryVideoControlled &&
      state.stream.egLiveVideoControlled
  )
  const popoutMode = useSelector(state => state.window.popoutMode)

  //event redux stuff
  const event = useSelector(state => state.event.event)
  const donateMode = Number(event.live_settings.live_mode) === 1

  // items redux stuff
  const items = useSelector(state => state.items.items)
  const liveItem = items.find(i => i.is_live)

  const noContent = useMemo(() => {
    return !donateMode && !liveItem
  }, [liveItem, donateMode])

  return (
    <Box
      className={classnames(classes.actions, classes[orientation], {
        [classes.actionsMobile]: mobile,
        [classes.videoControlled]: videoControlled,
        [classes.isFullscreen]: fullScreen || windowFullscreen,
        [classes.noContent]: noContent,
        [classes.hideEngagements]: !event.live_settings.show_engagements,
        [classes.donateMode]: event.live_settings.live_mode,
        [classes.popoutMode]: popoutMode
      })}
    >
      {!hideControls && (
        <Fragment>
          {!donateMode && liveItem && (
            <Fragment>
              {liveItem.item_type === 'auction' && <BidButton />}
              {liveItem.item_type === 'fixed' && <FixedButton />}
            </Fragment>
          )}
          {donateMode && <DonateButtons />}
        </Fragment>
      )}
    </Box>
  )
}

export default EngagementButtons



// WEBPACK FOOTER //
// ./src/components/EngagementButtons/index.jsx